export const EDIT_TEST_SECTIONS = {
    OVERVIEW: { key: 'overview', text: 'overview', value: 'overview' },
    CARD: { key: 'card', text: 'card', value: 'card' },
    INSTRUCTIONS: { key: 'instructions', text: 'instructions', value: 'instructions' },
    SCORING: { key: 'scoring', text: 'scoring', value: 'scoring' },
    QUESTIONS: { key: 'questions', text: 'questions', value: 'questions' },
    QUESTIONS_ORDER: { key: 'questionOrder', text: 'question order', value: 'questionOrder' },
    IMAGES: { key: 'imageGallery', text: 'image gallery', value: 'imageGallery' },
    SUBMIT: { key: 'submit', text: 'submit for review', value: 'submit' },
}

export const EDIT_FLASHCARD_DECK_SECTIONS = {
    OVERVIEW: { key: 'overview', text: 'overview', value: 'overview' },
    CARD: { key: 'card', text: 'card', value: 'card' },
    FLASHCARDS: { key: 'flashcards', text: 'flashcards', value: 'flashcards' },
    FLASHCARDS_ORDER: { key: 'flashcardsOrder', text: 'flashcards order', value: 'flashcardsOrder' },
    IMAGES: { key: 'imageGallery', text: 'image gallery', value: 'imageGallery' },
    SUBMIT: { key: 'submit', text: 'submit for review', value: 'submit' },
}